import { useMemo } from 'react'

import { useRequiredActiveOrg } from '~/hooks/org'
import { useRequiredAuthUser } from '~/hooks/useAuthUser'
import { OrgSigner } from '~/types'

export function useCurrentUserPasskeys(): OrgSigner[] {
  const org = useRequiredActiveOrg()
  const { id: userId } = useRequiredAuthUser()

  return useMemo(
    () => org.passkeys.filter((passkey) => passkey.user?.id === userId),
    [org.passkeys, userId],
  )
}
